import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { StripeService } from 'src/app/service/stripe.service';
import { PWUserService, SWUserService, UserService } from 'src/app/services/user.service';
import { PwAlertDialogComponent } from '../pw-alert-dialog/pw-alert-dialog.component';
import { AppService } from 'src/app/services/app.service';
import { UtilService } from 'src/app/services/util.service';
// import { AlertComponent } from '../alert/alert.component';
// import { StripeService } from '../service/stripe.service';


const emailRegex = '^[a-z0-9]+([._\\-]*[a-z0-9_\\-])*@[a-z0-9]+([._\\-]+[a-z0-9]+)+$';
export class PasswordValidation {

  static MatchPassword(AC: AbstractControl): ValidatorFn {
    const password = AC.get('email').value; // to get value in input tag
    const confirmPassword = AC.get('confirm').value; // to get value in input tag
    if (password !== confirmPassword) {
        AC.get('confirm').setErrors( {MatchPassword: true} );
    } else {
        return null;
    }
  }
}

@Component({
  selector: 'app-free-trial',
  templateUrl: './free-trial.component.html',
  styleUrls: ['./free-trial.component.scss']
})
export class FreeTrialComponent implements OnInit {
  public email = '';
  public cemail = '';
  public processing = '';
  public checked = true;
  public emailFormGroup: UntypedFormGroup;

  public loggedIn = false;

  emailControl: UntypedFormControl = new UntypedFormControl(null, [Validators.pattern(emailRegex), Validators.required]);
  cemailControl: UntypedFormControl = new UntypedFormControl(null, [Validators.pattern(emailRegex), Validators.required]);


  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<FreeTrialComponent>,
    private stripeService: StripeService,
    private userService: UserService,
    private utilService: UtilService
  ) {
    this.emailFormGroup = new UntypedFormGroup({
      email: this.emailControl,
      confirm: this.cemailControl
    }, {
      validators: PasswordValidation.MatchPassword
    });
  }

  ngOnInit(): void {
    const user = this.userService.getUser();
    if (user.email !== '' && user.email !== undefined && user.email !== 'user@naturalreaders.com') {
      this.email = user.email;
      this.cemail = user.email;
      this.loggedIn = true;
      this.emailFormGroup.disable();
    }
    this.sendGtag();
  }

  sendGtag() {
    this.utilService.gtag('config', { pageTitle: 'trial popup', pagePath: 'PW_3 Day_trial_payment' });
    this.utilService.gtag('event', { eventType: 'popup', eventCategory: 'PWTrialPayment', eventLabel: 'PW 3 Day Trial popup' });
  }

  isFieldValid(form: UntypedFormGroup, field: string) {
    return !form.get(field).valid && form.get(field).touched;
  }

  isEmailValid(form: UntypedFormGroup) {
    return form.invalid;
  }

  sendTrial() {
    this.processing = 'Your trial is being started...';
    this.checked = false;
    this.stripeService.createTrial(this.email).subscribe(data => {
      if (data['error'] !== '' && data['error'] !== undefined) {
        this.checked = true;
        this.processing = '';
        this.errHandler(data);
      } else {
        this.processing = '';
        this.checked = true;
        window.location = data['checkout'];
      }
    });

  }

  processPurchase(data) {
    const now = new Date();
    const nextBill = new Date(now.getFullYear(), 0, now.getDate()+3);
    // this.callGtagPurchase(data);
    // (window as any).rewardful('convert', { email: this.email });
    const purchaseSucStr = 'Your trial has started. Your next payment date is '
    + nextBill.toDateString()
    + '.\n\nIf you don\'t wish to subscribe anymore, turn off the'
    + ' licensing auto-renewal from the Subscription & Billing Settings.';
    
    let buttonText = 'OK';
    if (!this.loggedIn) {
      buttonText = 'Login/Signup with ' + this.email;
    }
    this.openDialog(purchaseSucStr, 'Welcome to your free trial!', buttonText).afterClosed().toPromise().then(_ => {
      this.dialogRef.close({purchased: true});
    });
  }

  errHandler(data) {
    if (data['error'] !== '' && data['error'] !== undefined) {
      console.log(data['error']);
      if (data['error'] === 'ERR_LIC_NOT_REC') {
        this.openDialog('Subscription not recognized, please contact our support for help');
      } else if (data['error'] === 'ERR_PREV_TRIAL' || data['error'] === 'ERR_PLAN_STILL_ACTIVE') {
        const redirDialog = true;
        this.openDialog('', 'Error', '', redirDialog);
      }
      else {
        this.openDialog(data['error']);
      }
    }
  }

  openDialog(msg: string, title = '', buttonText = 'OK', redirDialog = false) {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.width = '375px';
    dialogConfig.data = {
      type: 'alert',
      msg,
      title,
      buttonText
    };
    if (redirDialog) {
    dialogConfig.data.type = 'openPayment';
    }

    return this.dialog.open(PwAlertDialogComponent, dialogConfig);
  }

  closePayment() {
    this.dialogRef.close();
  }


  upgrade(type: string = 'prem') {
    if (AppService.isPW() || AppService.isAndroid() || AppService.isIOS()) {
      (this.userService as PWUserService).upgrade(type);
    } else if (AppService.isSoftware()) {
      (this.userService as SWUserService).upgrade(type);
    }
    this.dialogRef.close();
  }

}
